/** Spatial layer key the Norfolk Southern train positions publish under. */
export const NORFOLK_SOUTHERN_LAYER_KEY = 'norfolk_southern';

/**
 * Norfolk Southern's 24-hour emergency line, shown on the train card. Mirrors
 * the etl_integrations NORFOLK_SOUTHERN_SETTINGS.PHONE_NUMBER default, which
 * stamps the same number on each consist request.
 */
export const NORFOLK_SOUTHERN_EMERGENCY_LINE = '+18004532530';
